import React from 'react';
import { ButtonLink } from '../../../components/Button';
import { Column, Row } from '../../../components/Grid';
import { Section } from '../../../components/Section';
import { CType } from '../../../provider/Typo3Provider/types';

type CallToActionButtonProps = CType;

const CallToActionButton = ({
  header,
  header_link
}: CallToActionButtonProps) => (
  <Section>
    <Row horizontalAlignment="center">
      <Column large={4}>
        <ButtonLink large primary to={header_link || ''}>
          {header}
        </ButtonLink>
      </Column>
    </Row>
  </Section>
);

export default CallToActionButton;
